import { render } from "./SignOut.vue?vue&type=template&id=4b6149f8&lang=pug"
import script from "./SignOut.vue?vue&type=script&lang=js"
export * from "./SignOut.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__